import { ref } from 'vue';

// Shared "snapshot right before a state-changing action, restore verbatim on
// undo" helper. One implementation for delete-undo (Home.vue) and the
// archive/trash undos (DocketView.vue) — all three are the same shape:
// remember what a record looked like right before the action, offer a timed
// window to put it back exactly, then forget it.
export function useUndoableAction(timeoutMs = 5000) {
  const pending = ref(null);
  let timer = null;

  // Call right before performing the state-changing action, with whatever
  // data `undo` will need to put things back.
  function track(snapshot) {
    clearTimeout(timer);
    pending.value = snapshot;
    timer = setTimeout(() => { pending.value = null; }, timeoutMs);
  }

  // Call from the Undo handler — returns the tracked snapshot (or null if
  // the window already expired) and clears it so it can't be reused.
  function consume() {
    clearTimeout(timer);
    const snapshot = pending.value;
    pending.value = null;
    return snapshot;
  }

  // Call on unmount / when giving up on the pending undo without restoring.
  function clear() {
    clearTimeout(timer);
    pending.value = null;
  }

  return { pending, track, consume, clear };
}
